import {moment, Moment, toNumber} from 'vendor';

moment.defaultFormat = 'MMM D, YYYY';

moment.ISO8601 = 'YYYY-MM-DDTHH:mm:ssZ';

moment.parse = function parse(value) {
  if (moment.isMoment(value)) {
    return value;
  } else if (value && /^\d+$/.test(String(value))) {
    return moment.unix(toNumber(value));
  }
};

for (const locale of ['en', 'en-gb']) {
  moment.updateLocale(locale, {
    calendar: {
      lastDay: '[Yesterday]',
      sameDay: '[Today]',
      nextDay: '[Tomorrow]',
      thisYear: 'ddd, MMM D',
      sameElse: 'MMM D, YYYY'
    }
  });
}

moment.calendarFormat = function (day, now) {
  if (day.unix() === now.unix()) {
    return 'sameDay';
  } else if (day.unix() === now.clone().add(1, 'day').unix()) {
    return 'nextDay';
  } else if (day.unix() === now.clone().add(-1, 'day').unix()) {
    return 'lastDay';
  } else if (day.year() === now.year()) {
    return 'thisYear';
  }
  return '';
};

moment.prototype.range = function range(end: Moment) {
  if (this.isSame(end)) {
    return this.format('ddd, MMM D');
  } else if (this.format('MMM') === end.format('MMM')) {
    return this.format('MMM D - ').concat(end.format('D'));
  }
  return this.format('MMM D - ').concat(end.format('MMM D'));
};
